export default function postDomainReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'POST_DOMAIN_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'POST_DOMAIN_ERROR':
      return {...state, ...{error: action.error}};

    case 'POST_DOMAIN_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}